import type { IconSvgObject } from './types';

const Flag03Icon: IconSvgObject = [
  ["path", { d: "M4 21V8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4.00609 14.9977C4.00057 14.9977 3.99609 14.9932 3.99609 14.9877M3.99609 14.9877V3H19.9999L15.9826 8.99775L20 15L3.99609 14.9877Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Flag03Icon;
